export default {
  buttonTitle: {
    en: 'Create your account',
  },
}
